import React from 'react'
import { Route } from 'react-router-dom'
import { Campaigns, CreateCampaigns, Metrics, Templates } from '../../../views/Dashboard/Marketing'
import CampaignDetails from '../../../components/Marketing/Campaigns/ListingCampaigns/CampaignDetails'

const Marketing = ({ match }) => (
  <div>
    <Route path={`${match.path}/campaigns`} component={Campaigns} />
    <Route exact path={`${match.path}/campaigns/:id`} render={(props) => <CampaignDetails {...props} />} />
    <Route path={`${match.path}/metrics`} component={Metrics} />
    <Route path={`${match.path}/templates`} component={Templates} />
    <Route path={`${match.path}/create/campaigns`} component={CreateCampaigns} />
  </div>
)

export default Marketing
